import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import {
    BatteryDto,
    BatterySetDto,
    WorkTracker
} from '@flyfreely-portal-ui/flyfreely';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NoteType } from '../notes-edit/notes-edit.component';

@Component({
    selector: 'notes-view',
    templateUrl: './notes-view.component.html',
    styleUrls: ['./notes-view.component.scss']
})
export class NotesViewComponent implements OnInit, OnDestroy {
    @Input() source: BatteryDto | BatterySetDto;
    @Input() noteType: NoteType;
    @Output() edit = new EventEmitter<void>();
    hasEdit = false;
    canEdit = true;

    workTracker = new WorkTracker();
    private ngUnsubscribe$ = new Subject<void>();
    working = false;

    constructor() {
        this.workTracker.observable
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(working => (this.working = working));
    }

    ngOnInit(): void {
        this.refreshPermissions();
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    private refreshPermissions() {
        if (!this.source || !this.source.availableActions) {
            this.canEdit = false;
            return;
        }
        this.hasEdit = this.source.availableActions.hasEdit;
        this.canEdit = this.source.availableActions.canEdit;
    }

    editNotes() {
        this.edit.emit();
    }
}
